import * as z from 'zod';

export const ProdutoSchema = z.object({
  id: z.string(),
  qtdTitular: z.optional(
    z
      .string()
      .refine(val => Number(val) >= 0, { message: 'Não pode ser negativo' }),
  ),
  qtdDependente: z.optional(
    z
      .string()
      .refine(val => Number(val) >= 0, { message: 'Não pode ser negativo' }),
  ),
  total: z.optional(z.string()),
});
